import { action, observable, computed, makeObservable } from 'mobx';
import { updateWalletAddressApi } from '../../../api/products-api';

export default class AccessKey {
  name;
  accessKey;
  tradingAccountId;
  entity;
  isEnabled;

  constructor(key) {
    makeObservable(this, {
      name: observable,
      accessKey: observable,
      tradingAccountId: observable,
      entity: observable,
      isEnabled: observable,
      formattedAccessKey: computed,
      formattedAccessSecret: computed,
      update: action,
    });

    this.id = key.id;
    this.name = key.name;
    this.accessKey = key.access_key;
    this.tradingAccountId = key.trading_account_id;
    this.entity = key.entity;
    this.isEnabled = key.is_enabled;
    this.isPenalized = key.is_penalized;
  }

  get formattedAccessKey() {
    return `•••••••••••${this.accessKey || ''}`;
  }

  // The OTC trading account id is not sensitive, so surface it in the
  // table's secret column (labelled "Trading Account ID"); the real
  // secret is write-only and never returned.
  get formattedAccessSecret() {
    return this.tradingAccountId || '';
  }

  update = async (data) => {
    const response = await updateWalletAddressApi({
      id: this.id,
      ...data,
      entity: data.entity.id,
    });
    this.accessKey = response.access_key;
    this.tradingAccountId = response.trading_account_id;
    this.name = response.name;
    this.entity = data.entity;
    this.isEnabled = response.is_enabled;
  };
}
